import React from 'react';
import env from 'env';
import { useRouter } from 'components';
import { getStoreEditModel } from './storeEditFormModel';
import { Link, Redirect } from "react-router-dom";
import { usePost } from 'components';
import { useForm } from 'form';
import { Button, ErrorMessage } from 'components';

export function StoreNew(props) {
  const { query } = useRouter();
  const model = getStoreEditModel({});
  console.log(model)

  return <StoreEditForm model={model} />
}

function StoreEditForm({ model }) {
  const form = useForm(model, {});
  const post = usePost();

  const render = (name) => form.renderControl(name);

  function save(e) {
    form.validateForm(e, () => {
      const value = { ...form.getValue() };
      post.send(env.apiBase + "/api/storeAdmin/createStore", value);
    })
  }

  if (post.status === 'done') {
    console.log(post.response)
    const storeCode = post.response.results.storeCode;
    return <Redirect to={`/admin/store/edit/${storeCode}`} />
  }

  return (
    <div className="editor productEditor">
      <h1>New Store</h1>

      <section>
        <div className="row">
          <div className="col-md-9">{render('storeName')}</div>
        </div>
        <div className="row">
          <div className="col-12 actions">
            <ErrorMessage errors={form.errors} />
            <ErrorMessage errors={post.errors} />
            <Button onClick={save} status={form.status}>Create</Button>
            <Link className="btn btn-outline-dark" to="/admin/stores">Cancel</Link>
          </div>
        </div>
      </section>
    </div>
  );
}